import { useState, useCallback } from 'react'

import { graphQLQuery } from '@/hooks/hooks'
import QUERIES from '@/lib/graphql'
import type { Application } from '@/types/Activity'
import type { Touchpoint } from '@/types/Touchpoints'

const useTouchpoints = () => {
  const [isLoadingTouchpoints, setIsLoadingTouchpoints] = useState<boolean>(false)
  const [subjectTouchpoints, setSubjectTouchpoints] = useState<Touchpoint[]>([])

  const fetchSubjectTouchpoints = useCallback(async (application?: Application) => {
    setIsLoadingTouchpoints(true)
    const res = await graphQLQuery({
      query: QUERIES.getSubjectTouchpoints,
      variables: {
        customerId: application?.customerId,
        applicationId: application?.applicationId,
        subjectId: application?.subjectId,
      },
    })
    const { data } = await res.json()

    if (data && data.getSubjectTouchpoints) {
      setSubjectTouchpoints(data.getSubjectTouchpoints.reverse())
    }

    setIsLoadingTouchpoints(false)
  }, [])

  return {
    isLoadingTouchpoints,
    subjectTouchpoints,
    fetchSubjectTouchpoints,
  }
}

export default useTouchpoints
